import { render, staticRenderFns } from "./AnswerDialog.vue?vue&type=template&id=376b5f58&scoped=true"
import script from "./AnswerDialog.vue?vue&type=script&lang=ts"
export * from "./AnswerDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "376b5f58",
  null
  
)

export default component.exports